export function policyPlanTemplateReducer(state, action) {
  switch (action.type) {
    case 'load':
      return {
        ...state,
        templates: action.templates,
      };

    case 'move':
      return {
        ...state,
        templates: action.templates,
      };

    case 'remove':
      return {
        ...state,
        templates: state.templates.filter(
          (item) => parseInt(item.id) !== parseInt(action.templateId),
        ),
      };

    case 'edit':
      return {
        ...state,
        currentTemplate: action.template,
      };

    default:
      throw new Error();
  }
}
